import {
  OverviewEmojiGrid,
  OverviewItem,
  OverviewItemGrid,
  OverviewItemText,
} from 'components/styled/overview-items';
import { CreatorProfileDto } from 'types/creator-profile.type';

interface OverviewItemsProps {
  profile: CreatorProfileDto;
  isConversationEnabled: boolean;
}

export const OverviewItems = ({
  isConversationEnabled,
  profile,
}: OverviewItemsProps) => {
  return (
    <>
      <OverviewItem
        className="bg-overview bg-overview-photos"
        cols={1}
        rows={1}
      >
        <OverviewItemGrid>
          <OverviewEmojiGrid>📷</OverviewEmojiGrid>
          <OverviewItemText>{profile.roll.photosCount || 0}</OverviewItemText>
        </OverviewItemGrid>
      </OverviewItem>
      <OverviewItem
        className="bg-overview bg-overview-videos"
        cols={1}
        rows={1}
      >
        <OverviewItemGrid>
          <OverviewEmojiGrid>🎥</OverviewEmojiGrid>
          <OverviewItemText>{profile.roll.videosCount || 0}</OverviewItemText>
        </OverviewItemGrid>
      </OverviewItem>
      <OverviewItem
        className="bg-overview bg-overview-messages"
        cols={1}
        rows={1}
      >
        <OverviewItemGrid>
          <OverviewEmojiGrid>💬</OverviewEmojiGrid>
          <OverviewItemText>
            {isConversationEnabled ? 'yes' : 'no'}
          </OverviewItemText>
        </OverviewItemGrid>
      </OverviewItem>
    </>
  );
};
